module.exports = {
  REGISTRATION_STEP: {
    CONFIDENTIAL_AGREEMENT: 'CONFIDENTIAL_AGREEMENT',
    CUSTOMER_INTRODUCTION: 'CUSTOMER_INTRODUCTION',
    BUSINESS_BRIEF: 'BUSINESS_BRIEF',
    BUSINESS_ADDRESS: 'BUSINESS_ADDRESS',
    BUSINESS_INDUSTRIES: 'BUSINESS_INDUSTRIES',
    BUSINESS_USE_CASES: 'BUSINESS_USE_CASES',
    BUSINESS_COUNTRIES: 'BUSINESS_COUNTRIES',
    BUSINESS_SOURCE_OF_FUNDS: 'BUSINESS_SOURCE_OF_FUNDS',
    BUSINESS_STRUCTURE: 'BUSINESS_STRUCTURE',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    BENEFICIAL_OWNERS: 'BENEFICIAL_OWNERS',
    CONTROLLING_PARTY: 'CONTROLLING_PARTY',
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
    ID_VERIFICATION: 'ID_VERIFICATION',
    ACCOUNT_AGREEMENT: 'ACCOUNT_AGREEMENT'
  },
  REQUIRED_REGISTRATION_STEP_FOR_TNC_ACCEPT: {
    CONFIDENTIAL_AGREEMENT: 'CONFIDENTIAL_AGREEMENT',
    CUSTOMER_INTRODUCTION: 'CUSTOMER_INTRODUCTION',
    BUSINESS_BRIEF: 'BUSINESS_BRIEF',
    BUSINESS_ADDRESS: 'BUSINESS_ADDRESS',
    BUSINESS_INDUSTRIES: 'BUSINESS_INDUSTRIES',
    BUSINESS_USE_CASES: 'BUSINESS_USE_CASES',
    BUSINESS_COUNTRIES: 'BUSINESS_COUNTRIES',
    BUSINESS_SOURCE_OF_FUNDS: 'BUSINESS_SOURCE_OF_FUNDS',
    BUSINESS_STRUCTURE: 'BUSINESS_STRUCTURE',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    BENEFICIAL_OWNERS: 'BENEFICIAL_OWNERS',
    CONTROLLING_PARTY: 'CONTROLLING_PARTY'
  },
  REQUIRED_REGISTRATION_STEP_FOR_REGISTRATION_SUBMITTED_STATUS: {
    CONFIDENTIAL_AGREEMENT: 'CONFIDENTIAL_AGREEMENT',
    CUSTOMER_INTRODUCTION: 'CUSTOMER_INTRODUCTION',
    BUSINESS_BRIEF: 'BUSINESS_BRIEF',
    BUSINESS_ADDRESS: 'BUSINESS_ADDRESS',
    BUSINESS_INDUSTRIES: 'BUSINESS_INDUSTRIES',
    BUSINESS_USE_CASES: 'BUSINESS_USE_CASES',
    BUSINESS_COUNTRIES: 'BUSINESS_COUNTRIES',
    BUSINESS_SOURCE_OF_FUNDS: 'BUSINESS_SOURCE_OF_FUNDS',
    BUSINESS_STRUCTURE: 'BUSINESS_STRUCTURE',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    BENEFICIAL_OWNERS: 'BENEFICIAL_OWNERS',
    CONTROLLING_PARTY: 'CONTROLLING_PARTY',
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS'
  }
};
